import React, { useContext, useMemo } from 'react'
import { Spinner } from '@design-systems/canvas-ui'
import { useQuery } from '@apollo/client/react'
import { UserContext } from 'App/UserContext'
import { GET_USER_BY_ID } from 'graphql/queries/users/queries/userQueries'
import { AccountSettingsForm } from 'account/components/AccountSettingsForm'
import { PageLayout } from '@plm-core/utils'

export const AccountSettingsPage = () => {
  const { sparkUser } = useContext(UserContext)

  const { data, loading: userLoading } = useQuery(GET_USER_BY_ID, {
    variables: { id: sparkUser?.userProfileId ?? '' },
    skip: !sparkUser || !sparkUser?.userProfileId,
    fetchPolicy: 'network-only',
  })

  const userData = useMemo(() => {
    return data?.getById
  }, [data])

  if (userLoading) {
    return (
      <PageLayout>
        <Spinner />
      </PageLayout>
    )
  }

  if (!userData) {
    return
  }

  return (
    <PageLayout>
      <AccountSettingsForm userData={userData} />
    </PageLayout>
  )
}
